import React, { Suspense, useState, useEffect } from "react";
import systemListingService from "./SystemListingServices";
import Pagination from "components/Common/newPagination";

export default function ClassListPage(param: any) {

  let [searchReleaseIsrc, setSearchReleaseIsrc] = useState<string>("");
  let [searchText, setSearchText] = useState<string>("");
  let [ClassListCount, SetClassListCount] = useState(0);
  let [editingOn, setEditingOn] = useState<boolean>(false);
  let [classListCount, SetclassListCount] = useState(0);
  let [ClassListing, SetClassListing] = useState<any>([]);
  let [searchZone, setSearchZone] = useState<string>("");
  let [searchFormatCode, setSearchFormatCode] = useState<string>("");


  var payload = {
    pageNumber: 1,
    pageSize: 10,
    format: searchFormatCode,
    territoryCode: searchZone
  }

  const classListSelect = () => {
    ClassListing = [];
    SetClassListing(ClassListing)

    classListCount = 0
    SetclassListCount(classListCount)

    systemListingService.MechanicalRateListing(payload).then((res:any) => {
      ClassListing = res;
      SetClassListing(ClassListing)
      classListCount = res[0].totalRows
      SetclassListCount(classListCount)
    })
  }

  const onPageChange = (e: any) => {
    console.log(e)
    payload.pageNumber = e.pageNumber;
    payload.pageSize = e.pageSize;
    classListSelect();
  }

  return (
    <div className="ws-12">
      <div className="content-card">

        <div className=" ws-12">

          <div className="pull-right ws-12">

            <div className="ws-12">
              <div className=" pull-left text-bold">MPM / Class List</div>

              <button className="icon-btn info pull-right" type="button" onClick={() => setEditingOn((prev) => !prev)}   >
                {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}
              </button>
              <span className="pt mt pull-right">
                {ClassListCount ? ClassListCount : 0} record(s) found
              </span>
            </div>

            <div className="ws-12">

              <div className="ws-4 pm">
                <label className="text-bold">ReleaseISRC</label>
                <input className="form-input" placeholder="Enter releaseISRC" value={searchReleaseIsrc} onChange={(e) => setSearchReleaseIsrc(e.target.value)} />
              </div>

              <div className="ws-4 pm">
                <label className="text-bold">Search Text</label>
                <input className="form-input" placeholder="Enter searchText" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
              </div>

              <div className="ptl pull-right">
                <button type="button" className="icon-btn primary mtll pbl" >⊕ Add Class List </button>

                <button type="button" className="icon-btn primary mtll pbl" onClick={classListSelect}>
                  <i className="icon-search"></i>
                  Search
                </button>
              </div>

            </div>

          </div>
        </div>

        <div className="table-wrapper">

          <div className="table-scroll">
            {classListCount > 0 && <table>
              <thead>
                <tr>
                  <th>ReleaseISRC</th>
                  <th>Class List</th>
                  <th>ReleaseAlt1</th>
                  <th>ReleaseAlt2</th>
                  <th>ReleaseAlt3</th>
                  <th>ReleaseAlt4</th>
                  <th>ReleaseAlt5</th>
                  <th>ReleaseAlt6</th>
                </tr>
              </thead>
              <tbody>
                {ClassListing.map((row: any) => (
                  <tr key={row.id}>
                    <td>{row.releaseIsrc}</td>
                    <td>{row.classList}</td>
                    <td>{row.releaseAlt1}</td>
                    <td>{row.releaseAlt2}</td>
                    <td>{row.releaseAlt3}</td>
                    <td>{row.releaseAlt4}</td>
                    <td>{row.releaseAlt5}</td>
                    <td>{row.releaseAlt6}</td>
                  </tr>
                ))}
              </tbody>
            </table>}

            {classListCount === 0 && <div className="ws-12">
              <div className="alert alert-info ws-12 box" >No records to display</div>
            </div>}

            {(classListCount > 0 && classListCount > 10) && <Pagination totalRow={classListCount} onPageChange={onPageChange} />}
          </div>

        </div>

      </div>
    </div>
  );
};